import { NgModule } from '@angular/core';
import { INTERCEPTORS } from '@app/shared/interceptors';
import { SafePipe } from '@app/shared/pipes/safe.pipe';
import { CopyToClipboardDirective } from '@app/shared/directives/copy-to-clipboard.directive';
import { AppHttpClient } from '@app/shared/services/http.service';
import { CopyToClipboardService } from '@app/shared/services/copy-to-clipboard.service';
import { CommonModule, DatePipe } from '@angular/common';
import { LocalStorageService } from '@app/shared/services/local-storage';
import { SessionStorageService } from '@app/shared/services/session-storage';
import { QrCodeService } from '@app/shared/services/qr-code.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerComponent } from '@app/shared/components/progress-spinner/progress-spinner.component';
import { PrivateHeaderComponent } from '@app/shared/components/private-header/private-header.component';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { CodeVerifierComponent } from '@app/shared/components/code-verifier/code-verifier.component';
import { PasswordComplexityCheckComponent } from '@app/shared/components/password-complexity-check/password-complexity-check.component';
import { PinComplexityCheckComponent } from '@app/shared/components/pin-complexity-check/pin-complexity-check.component';
import { CardModule } from 'primeng/card';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { FormConstructorComponent } from '@app/shared/components/form-constructor/form-constructor.component';
import { IconFeatherComponent } from '@app/shared/components/icon-feather/icon-feather.component';
import { SidebarModule } from 'primeng/sidebar';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { TogglePasswordVisibilityComponent } from '@app/shared/components/toggle-password-visibility/toggle-password-visibility.component';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { GiveAccessComponent } from '@app/shared/components/give-access/give-access.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuComponent } from '@app/shared/components/menu/menu.component';
import { DialogModule } from 'primeng/dialog';
import { AddContactFormComponent } from '@app/shared/components/add-contact-form/add-contact-form.component';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { SignatureComponent } from '@app/shared/components/signature/signature.component';
import { CareGuideChatComponent } from '@app/shared/components/care-guide-chat/care-guide-chat.component';
import { EmergencySummaryCardComponent } from '@app/shared/components/emergency-summary-card/emergency-summary-card.component';
import { PascalCasePipe } from '@app/shared/pipes/pascal-case.pipe';
import { RoleLabelPipe } from '@app/shared/pipes/role-label.pipe';
import { ScopeLabelPipe } from '@app/shared/pipes/scope-label.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

const imports = [
  CommonModule,
  FormsModule,
  RouterModule,
  ReactiveFormsModule,
  HttpClientModule,

  // PrimeNG
  ButtonModule,
  InputTextModule,
  ToastModule,
  MessageModule,
  MessagesModule,
  PasswordModule,
  DividerModule,
  CardModule,
  AvatarModule,
  AvatarGroupModule,
  BadgeModule,
  MenuModule,
  CalendarModule,
  InputNumberModule,
  DropdownModule,
  InputMaskModule,
  RadioButtonModule,
  CheckboxModule,
  ProgressBarModule,
  SidebarModule,
  TabViewModule,
  TooltipModule,
  OverlayPanelModule,
  InputSwitchModule,
  DialogModule,
  TableModule,

  InfiniteScrollModule,
];

const declarations = [
  ProgressSpinnerComponent,
  PrivateHeaderComponent,
  CodeVerifierComponent,
  PasswordComplexityCheckComponent,
  PinComplexityCheckComponent,
  FormConstructorComponent,
  IconFeatherComponent,
  TogglePasswordVisibilityComponent,
  GiveAccessComponent,
  MenuComponent,
  AddContactFormComponent,
  IconComponent,
  SignatureComponent,
  CareGuideChatComponent,
  EmergencySummaryCardComponent,

  // Pipes
  SafePipe,
  PascalCasePipe,
  RoleLabelPipe,
  ScopeLabelPipe,

  // Directives
  CopyToClipboardDirective,
];

const providers = [
  AppHttpClient,
  CopyToClipboardService,
  LocalStorageService,
  SessionStorageService,
  QrCodeService,
  MessageService,
  DatePipe,
  ...INTERCEPTORS,
];

@NgModule({
  imports,
  providers,
  declarations,
  exports: [...imports, ...declarations],
})
export class SharedModule {}
